import { type HTMLProps, useRef } from 'react';
import { type AriaButtonProps, useButton } from '@react-aria/button';

export type DatePickerButtonProps = HTMLProps<HTMLButtonElement> & AriaButtonProps<'button'>;

export function DatePickerButton({ children, className, ...rest }: DatePickerButtonProps) {
  const ref = useRef<HTMLButtonElement>(null);
  const { buttonProps } = useButton(rest, ref);

  return (
    <button className={className} ref={ref} type="button" {...buttonProps}>
      {children}
    </button>
  );
}
